module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notFoundPage"
  }, [_c('blockquote', [_c('h2', [_vm._v("Error 404 Not Found")]), _vm._v(" "), _c('p', [_vm._v("Our apologies for the temporary inconvenience. The requested URL was not found on this server.  We suggest you try one of the links below:")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Verify url and typos")]), _vm._v(" - The web page you were attempting to view may not exist or may have moved - try "), _c('em', [_vm._v("checking the web address for\n      typos")]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("E-mail us")]), _vm._v(" - If you followed a link from somewhere, please let us know at "), _c('a', {
    attrs: {
      "href": "mailto:hj3157@iwmedia.co.kr"
    }
  }, [_vm._v("hj3157@iwmedia.co.kr")]), _vm._v("\n      . Tell us where you came from and what you were looking for, and we'll do our best to fix it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1a28bce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = 872
// module chunks = 1